export default __webpack_public_path__ + "static/media/mark_cook.347aaa3f.jpg";